import * as React from 'react';
import { iconName } from '../icons/Icons';
import { DateInput, DateInputProps } from '../inputs/DateInput';
import { FormField } from './FormField';

type DateInputFieldProps = DateInputProps & {
    label:string,
    infoMessage?:string,
    hideLabel?:boolean,
    icon?: iconName,
    width?:string,
    validator:(value:Date|null) => { valid:true } | {valid:false, errorMessage:string}
};

export function DateInputField(props:DateInputFieldProps)
{
    const validatorResult = props.validator(props.value);

    return (
        <FormField 
            label={props.label}
            hideLabel={props.hideLabel}
            inputComponent={
                
                <DateInput {...props} inErrorState={!validatorResult.valid} />
                
            }
            inErrorState={!validatorResult.valid}
            message={validatorResult.valid===true ? props.infoMessage || '' : validatorResult.errorMessage}
        />
    )
}